import React, {FC, useMemo} from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {GatsbyImage} from 'gatsby-plugin-image';
import {getImage, GraphQLImage} from 'utils/types/image';

interface DynamicAssetProps {
	alt?: string;
	className?: string;
	imageSrc: string;
}

interface DataProps {
	altText: string
	file: GraphQLImage
	static: string
}

interface StaticProps {
	assets: {
		nodes: {
			data: DataProps
		}[]
	}
}

const query = graphql`
query {
	assets: allAirtable(
		filter: {
			table: {eq: "Assets"}
			data: {Ext: {in: [".jpg", ".png"]}}
		}
	) {
		nodes {
			data {
				altText: Name
				static: Static_URL
				file: File {
					localFiles {
						childImageSharp {
							gatsbyImageData(width: 1536)
						}
					}
				}
			}
		}
	}
}`;

const DynamicAsset: FC<DynamicAssetProps> = ({alt, className, imageSrc}) => {
	const data: StaticProps = useStaticQuery(query);
	const assets = useMemo(() => {
		const assets: {[key: string]: DataProps} = {};
		for (const node of data.assets.nodes) {
			assets[node.data.static] = node.data;
		}
		return assets;
	}, [data]);

	const asset = assets[imageSrc];
	if (asset) {
		return (
			<GatsbyImage
				image={getImage(asset.file)}
				alt={alt || asset.altText}
				className={className}
			/>
		);
	}

	return (
		<img src={imageSrc} alt={alt || ''} className={className} />
	);
};

export default DynamicAsset;
